<div class="notify-container" #notificationsContainer>
    <ng-container *ngIf="allNotifs$ | async as allNotifs; else loading">
        <ng-container *ngIf="allNotifs.length > 0; else noNotifications">
            <!-- Notification app buttons -->
            <div class="notifications-wrapper">
                <mat-button-toggle-group
                    class="notif-app-buttons"
                    (click)="updateNotifPaneBodyHeight()"
                    multiple
                >
                    <mat-button-toggle
                        class="notif-button-toggle"
                        *ngFor="let filter of filterButtons$ | async"
                        appInsightsTrack
                        value="{{filter.title}}"
                        [eventData]="filter"
                        loc="{{consts.APP_INSIGHTS_LOC}}"
                        (click)="filterNotifications(filter.title)"
                        checked="{{notifFilters.includes(filter.title)}}"
                    >
                        {{filter.title}}
                        <span class="count">{{filter.count}}</span>
                    </mat-button-toggle>
                </mat-button-toggle-group>
            </div>

            <mat-tab-group mat-align-tabs="left" (selectedTabChange)="updateNotifPaneBodyHeight()"
                (mouseenter)="updateNotifPaneBodyHeight()"> 
                <!-- All tab -->
                <mat-tab label="{{consts.LABEL_TAB_ALL}}">
                    <p class="notif-day">{{consts.LABEL_TODAY}}</p>
                    <ng-container *ngIf="allNotifs$ | async as allNotifs; else loading">
                        <ng-container *ngIf="allNotifs.length > 0; else tabNoNotifications">
                            <ng-container *ngFor="let item of allNotifs">
                                <app-notification-card
                                    *ngIf="notifFilters.length <= 0 || notifFilters.includes(item.title)"
                                    [data]="item"
                                    (clearNotificationEvent)="refreshNoifList()"
                                >
                                </app-notification-card>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </mat-tab>

                <!-- Notifications tab -->
                <mat-tab label="{{consts.LABEL_TAB_NOTIFICATIONS}}">
                    <ng-container *ngIf="notifications$ | async as notifications; else loading">
                        <ng-container *ngIf="notifications.length > 0; else tabNoNotifications">
                            <ng-container *ngFor="let item of notifications">
                                <app-notification-card
                                    *ngIf="notifFilters.length <= 0 || notifFilters.includes(item.title)"
                                    [data]="item"
                                    (clearNotificationEvent)="refreshNoifList()"
                                >
                                </app-notification-card>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </mat-tab>
                <!-- Tasks tab: -->
                <mat-tab label="{{consts.LABEL_TAB_TASKS}}">
                    <ng-container *ngIf="tasks$ | async as tasks; else loading">
                        <ng-container *ngIf="tasks.length > 0; else tabNoNotifications">
                            <ng-container *ngFor="let item of tasks">
                                <app-notification-card
                                    *ngIf="notifFilters.length <= 0 || notifFilters.includes(item.title)"
                                    [data]="item"
                                >
                                </app-notification-card>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </mat-tab>

                <!-- Alerts tab -->
                <mat-tab label="{{consts.LABEL_TAB_ALERTS}}">
                    <!-- TODO: Replace ng-container template reference from tabNoNotifications to loading once alerts are available -->
                    <ng-container *ngIf="alerts$ | async as alerts; else tabNoNotifications">
                        <ng-container *ngIf="alerts.length > 0; else tabNoNotifications">
                            <ng-container *ngFor="let item of alerts">
                                <app-notification-card
                                    *ngIf="notifFilters.length <= 0 || notifFilters.includes(item.title)"
                                    [data]="item"
                                >
                                </app-notification-card>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </mat-tab>
            </mat-tab-group>
        </ng-container>

        <!-- Empty tab -->
        <ng-template #tabNoNotifications>
            <div class="empty-tab-wrapper">
                <mat-icon svgIcon="hub_notification_empty"></mat-icon>
                <p>{{consts.NO_NOTIFICATIONS}}</p>
            </div>
        </ng-template>
    </ng-container>

    <!-- Tab loading -->
    <ng-template #loading>
        <div class="loading-spinner">
            <mat-spinner [diameter]="50"></mat-spinner>
        </div>
    </ng-template>

    <!-- Empty notifications  -->
    <ng-template #noNotifications>
        <div class="empty-notif-wrapper">
            <mat-icon svgIcon="hub_notification_empty"></mat-icon>
            <p>{{consts.NO_NOTIFICATIONS}}</p>
        </div>
    </ng-template>
</div>
